// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zbbaX","colMin":"styles_colMin__fvo0X"};